import { GroupStartInstructionContainer } from "../containers/GroupStartInstructionContainer"

export const GroupInstructionsStartPage = () => (
    <GroupStartInstructionContainer/>
)